<template>
    <div>
        <template v-if="devcMaintInfo != null && devcMaintInfo.id != null">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>设备保养分项</span>
                </div>
            </div>
            <el-table :data="devcMaintItemList" border style="width: 100%" class="mt30">
                <el-table-column prop="shopName" label="零售机构" align="left"></el-table-column>
                <el-table-column prop="devcTitle" label="设备名称" width="200" align="left"></el-table-column>
                <el-table-column prop="devcNo" label="系统编号" width="220" align="left"></el-table-column>
            </el-table>
        </template>
        <div class="font14 align-center font-gray2" style="margin-top: 100px;" v-else>无设备保养信息...</div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-devc-maint-info',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '设备保养信息-详情',
        props: ['workVoucherId'],
        data: function () {
            return {
                devcMaintInfo: {},
                devcMaintItemList: [],
            }
        },
        created: function () {
            if(!Utils.isNoB(this.workVoucherId)) {
                this.getDevcMaintInfo();
            }
        },
        methods: {
            getDevcMaintInfo: function () {
                let self = this;
                let params = {
                    id: self.workVoucherId
                };
                servcDelivApi.getDevcMaintInfo(params, function (result) {
                    if(result.type === "info") {
                        let devcMaintInfo = result.data;
                        //
                        if(devcMaintInfo != null) {
                            self.devcMaintItemList = devcMaintInfo.itemList || [];
                            self.devcMaintInfo = devcMaintInfo;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showBigImg: function (url) {
                Utils.setPageUrl(url, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/DevcMaintInfo.vue